/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ThorServerDataParser} from "../ThorServerDataParser";
import {IThorInitData} from "./IThorServerData";
import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ThorGameMode} from "../../gamemode/ThorGameMode";

export class ThorParsedInitData extends ParsedInitData {

    private _payoutMultiplier:number;
    private _collectedScatters:number;
    private _landedScatterCount:number;
    private _nudgeRespinTriggerdThisSpin:boolean;
    private _scatterRespinTriggeredThisSpin:boolean;
    private _isRandomWild:boolean;
    private _isReelWild:boolean;

    constructor(rawData:IThorInitData, dataParser:ThorServerDataParser) {
        super(rawData, dataParser);
        this._payoutMultiplier = rawData.payoutMultiplier;
        this._collectedScatters = rawData.collectedScatters;
        this._landedScatterCount = rawData.landedScatterCount;
        this._nudgeRespinTriggerdThisSpin = rawData.nudgeRespinTriggerdThisSpin;
        this._scatterRespinTriggeredThisSpin = rawData.scatterRespinTriggeredThisSpin;
        this._isRandomWild = rawData.isRandomWild;
        this._isReelWild = rawData.isReelWild;
    }

    protected isRespin(rawData:IServerData):boolean {
        return this.mode === GameMode.RESPIN || this.mode == ThorGameMode.NUDGE_RESPIN;
    }

    protected isNextRespin(rawData:IServerData):boolean {
        return this.nextMode === GameMode.RESPIN || this.nextMode == ThorGameMode.NUDGE_RESPIN;
    }


    protected isFreespin(rawData:IServerData):boolean {
        return super.isFreespin(rawData) || this.mode == ThorGameMode.NUDGE_RESPIN_FS;
    }

    protected isNextFreespin(rawData:IServerData):boolean {
        return super.isNextFreespin(rawData) || this.nextMode == ThorGameMode.NUDGE_RESPIN_FS;
    }

    get payoutMultiplier():number {
        return this._payoutMultiplier;
    }

    get collectedScatters():number {
        return this._collectedScatters;
    }

    get landedScatterCount():number {
        return this._landedScatterCount;
    }

    get nudgeRespinTriggerdThisSpin():boolean {
        return this._nudgeRespinTriggerdThisSpin;
    }

    get scatterRespinTriggeredThisSpin():boolean {
        return this._scatterRespinTriggeredThisSpin;
    }

    get isRandomWild():boolean {
        return this._isRandomWild;
    }

    get isReelWild():boolean {
        return this._isReelWild;
    }
}